// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__eDv6i","sendOtp":"AuthorizeToLogin_sendOtp__2ltB1"};